import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "googleDocs",
  "name": "Google Docs",
  "category": "integrations",
  "description": "Create and edit Google Docs documents",
  "icon": "siGoogledocs",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Google Docs",
    "color": "#4285f4"
  },
  "credentials": [
    {
      "name": "googleDocsOAuth2",
      "required": true,
      "displayName": "Google Docs OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "google",
    "docs",
    "documents",
    "text",
    "writing"
  ],
  "comingSoon": true
};

export default definition;
